import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ArrowRight, Quote } from "lucide-react";
import Reveal from "../motion/Reveal";
import { testimonials } from "../../data/content";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const prev = () => setI((v) => (v - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((v) => (v + 1) % testimonials.length);

  return (
    <section
      className="relative bg-white py-32 lg:py-44 border-t border-brand-border"
      data-testid="testimonials-section"
    >
      <div className="max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-14 lg:mb-20">
          <Reveal>
            <p className="eyebrow">Stimmen</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-balance">
              Was Kunden über die Zusammenarbeit sagen.
            </h2>
          </Reveal>
        </div>

        <div className="relative border-t border-brand-border pt-14 lg:pt-20">
          <Quote
            className="absolute -top-8 left-0 h-16 w-16 text-brand-accent/20"
            aria-hidden
          />

          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
              className="max-w-4xl"
              data-testid={`testimonial-${i}`}
            >
              <p className="font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-brand-primary text-balance">
                “{t.quote}”
              </p>
              <footer className="mt-10 flex items-center gap-4">
                <div className="h-12 w-12 rounded-full bg-brand-primary text-white grid place-items-center font-medium">
                  {t.author.split(" ").map((n) => n[0]).slice(0, 2).join("")}
                </div>
                <div>
                  <div className="font-medium">{t.author}</div>
                  <div className="text-brand-muted text-sm">{t.role}</div>
                </div>
              </footer>
            </motion.blockquote>
          </AnimatePresence>

          <div className="mt-14 flex items-center justify-between">
            <div className="text-brand-muted text-sm">
              <span className="text-brand-primary font-medium">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="mx-1">/</span>
              <span>{String(testimonials.length).padStart(2, "0")}</span>
            </div>

            <div className="flex items-center gap-3">
              <button
                type="button"
                aria-label="Vorheriges Zitat"
                onClick={prev}
                data-testid="testimonial-prev"
                className="h-12 w-12 rounded-full border border-brand-border hover:border-brand-primary hover:bg-brand-primary hover:text-white transition-colors grid place-items-center"
              >
                <ArrowLeft className="h-4 w-4" />
              </button>
              <button
                type="button"
                aria-label="Nächstes Zitat"
                onClick={next}
                data-testid="testimonial-next"
                className="h-12 w-12 rounded-full border border-brand-border hover:border-brand-primary hover:bg-brand-primary hover:text-white transition-colors grid place-items-center"
              >
                <ArrowRight className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
